import React from "react";
import Image from "next/image";
import { Box, AspectRatio } from "@chakra-ui/react";
import { type AccordionItemProps } from ".";

export function MobileImage({ image, imageAlt, customFigure, label }: AccordionItemProps) {
  return (
    <AspectRatio
      display={{ base: "block", md: "none" }}
      ratio={5 / 4}
      bgGradient="linear(-45deg, oceanGradientLight, oceanGradientDark)"
      borderRadius="md"
      w="100%"
      maxW="sm"
      mx="auto"
      mt={6}
      overflow="hidden"
    >
      <>
        {image && (
          <Image
            fill
            src={image}
            alt={imageAlt ?? label}
            sizes="100%"
            style={{ objectFit: "contain", borderRadius: "6px", padding: "16px" }}
          />
        )}

        {customFigure && (
          <Box w="100%" h="100%" padding={4}>
            {customFigure}
          </Box>
        )}
      </>
    </AspectRatio>
  );
}
